<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/driver";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Drivers",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('drivers.singular')) }},
    resourceRoute: {default: 'drivers'},
    modelVariable: {default: 'driver'},
    form: {default() { return FormsModel; }},
    denyDelete: {type: Boolean, default: true}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('drivers.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('drivers.plural')),
          href: "/drivers",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/drivers/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/drivers/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/drivers/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/drivers/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/drivers/${this.$route.params.key}`)
    }
  }
}
</script>
